<template>
    <div class="flex justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            :class="['animate-spin', sizeClass]" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-loader-circle-icon lucide-loader-circle">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: null
        }
    },
    computed: {
        sizeClass() {
            const sizeMap = {
                'sm': 'w-4 h-4',
                'md': 'w-6 h-6',
                'lg': 'w-8 h-8'
            }
            return sizeMap[this.size] || 'w-5 h-5'
        }
    }
}
</script>
